import { AfterViewInit, Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { ClientsApiService } from '../../../../core/api/services';
import { AuthService } from '../../../../main';
import { AlertService } from '../../../../shared/services/alert.service';
import { environment } from '../../../../../environments/environment';
import { ArkUserType, ClientModel, ClientPermissionViewModel, ClientRoleViewModel, ClientUserRolesViewModel, ClientUserViewModel } from '../../../../core/api/models';
import { Utils } from '../../../../core/utils';

@Component({
  selector: 'app-client-user',
  templateUrl: './client-user.component.html',
  styleUrl: './client-user.component.css',
  standalone: false
})
export class ClientUserComponent implements OnInit {

  currentItem?: ClientModel;
  client_id: number | null = null;
  baseDomain: string | null = environment.baseDomain;

  roles: ClientRoleViewModel[] = [];
  permissions: ClientPermissionViewModel[] = [];
  clientUserItem?: ClientUserViewModel;
  loading: boolean = false;

  constructor(private authService: AuthService,
    private route: ActivatedRoute,
    private router: Router,
    private alertService: AlertService,
    private apiService: ClientsApiService,
    private sanitizer: DomSanitizer) {

  }

  ngOnInit(): void {
    this.route.paramMap.subscribe((params: ParamMap) => {
      let ID = + (params.get('ID') || '0');
      let clientUserID = + (params.get('UserID') || '0');
      if (ID > 0) {
        this.client_id = ID;
        console.info('Loading ' + ID);


        this.apiService.GetClientRoles({ clientID: ID })
          .forEach(data => {
            this.roles = data;
          }).catch(
            err => {
              this.alertService.error(Utils.getAjaxError(err));

            });
            
        this.apiService.GetClientPermissions({ clientID: ID })
          .forEach(data => {
            this.permissions = data;
            
          }).catch(
            err => {
              this.alertService.error(Utils.getAjaxError(err));

            });

        this.apiService.Get({ body: { id: ID } })
          .forEach(data => {
            this.currentItem = data;
          }).catch(
            err => {
              this.alertService.error(Utils.getAjaxError(err));

            });
        if (clientUserID > 0) {
          this.apiService.GetClientUser({ clientID: ID, clientUserID: clientUserID })
            .forEach(data => {
              this.clientUserItem = data;
            }).catch(
              err => {
                this.alertService.error(Utils.getAjaxError(err));

              });
        }
      }
      
    });


    this.authService.checkIfAutorized([ArkUserType.Marketing, ArkUserType.Admin, ArkUserType.Impersonator]);

  }



  save() {

    this.loading = true;
    this.apiService.SaveClientUser({ clientID: this.currentItem?.ID ?? 0, body: this.clientUserItem })
      .forEach(
        (savedItem) => {

          this.loading = false;
          
          this.alertService.success('Client data saved successfully');
          this.router.navigate([`/clients/${this.currentItem?.ID}/Users`]);

        }
      ).catch(
        err => {
          this.loading = false;
          this.alertService.error(Utils.getAjaxError(err));

        }
      );
  }

  editOnOpto() {

    this.loading = true;
    this.apiService.GetClientLink({ clientID: this.currentItem?.ID ?? 0 })
      .forEach(
        (r) => {
          this.loading = false;
          window.open(r + "/Administration/ManageUsers/Edit/" + this.clientUserItem?.ID, this.currentItem!.SiteName || '_blank');
        }
      ).catch(
        err => {
          this.loading = false;
          this.alertService.error(Utils.getAjaxError(err));
        }
      );
  }
  resetPassword() {
    this.alertService.confirm("Reset user password", "Are you sure?")
      .subscribe(response => {
        if (response) {

          this.loading = true;
          this.apiService.ResetClientUserAccessCredentials({ clientID: this.currentItem?.ID ?? 0, clientUserID: this.clientUserItem?.ID ?? 0 })
            .forEach(
              () => {
                this.loading = false;
                this.alertService.success('Password reset sent!');
              }
            ).catch(
              err => {
                this.loading = false;
                this.alertService.error(Utils.getAjaxError(err));

              }
            );
        }
      });

  }
}
